import React from 'react';
import { connect } from 'react-redux';
import { setResumeData } from '../../actions/resume';
import Spinner from '../Spinner';
import Resume from '../Resume';
import ContextMenu from '../ContextMenu';
import { PlayList, Cover, MusicActions, Separator } from '../../packages/components'; // por cambiar PlayList
import Device from '../../devices/device';
import MusicUtils from "../../actions/musica/music-actions";

import './playlistdetail.scss';
import * as api from '../../requests/loader';
import { addToContextMenu } from '../../actions/musica/context-menu-actions';
import { doPGMPlaylist } from '../../actions/musica/player-shared-action-creators';
import { playFullMedia } from '../../actions/playmedia';
import logger from 'src/utils/logger/logger';
import {fetchLoginDynamic} from '../../reducers/user';
import PlayerTracksUtil from '../../utils/PlayerTracksUtils';
import PLAYERTRACK_TYPE from '../../containers/Music/playerTracksType';
import { AAFPLAYER_PLAY } from '../../AAFPlayer/constants';
import LayersControl from '../../utils/LayersControl';
import PlaceHolder from '../../containers/Placeholder';
import store from '../../store';

const mapDispatchToProps = dispatch => ({
    setResumeData: data => dispatch(setResumeData(data)),
    doPGMPlaylist: (index, state) => dispatch(doPGMPlaylist(index, state)),
    addToContextMenu: currentContent => dispatch(addToContextMenu(currentContent)),
    playFullMedia: pgm => dispatch(playFullMedia(pgm)),
    fetchLoginDynamic: (email) => dispatch(fetchLoginDynamic(email))
});

class NewPlaylistDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            playlistId: props.match.params.groupId,
            data: null,
            selectedSong: null,
            components: [],
            isFetching: true,
            error: null
        };
        this.handlePlayClick = this.handlePlayClick.bind(this);
        this.handleToggleFollowClick = this.handleToggleFollowClick.bind(this);
        this.handleMoreClick = this.handleMoreClick.bind(this);
        this.handlePlayListOnClick = this.handlePlayListOnClick.bind(this);
        this.handlePlayListOnFocus = this.handlePlayListOnFocus.bind(this);
        this.handlePlayListOnBlur = this.handlePlayListOnBlur.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.keys = Device.getDevice().getKeys();
        this.contextMenu = null;
        this.endOfPlayList = false;
        this.songsTotal = 0;
    }

  componentWillMount() {
    this.props.fetchLoginDynamic(this.props.user.email);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.user.musicUser){
        this.getData();
      }
    }

    async getData() {
        const { playlistId } = this.state;
        const params = {
            list_id: playlistId
        };
        try {
            const response = await api.getPlaylistDetail(params)
            const response2 = await api.getHasUserInteractions(params, this.props.user)

            if (response) {
                if(response === 'Forbidden'){
                  this.setState({
                    isFetching: false,
                    error: response,
                  });
                }
                else{
                  response.data.isFollowed = response2 && response2.isFollowing && response2.isFollowing.playlists[0] ? response2.isFollowing.playlists[0].includes(params.list_id) : false;
                  this.setResume(response.data);
                  this.setState(
                    {
                      isFetching: false,
                      data: response.data,
                      components: response.components,
                      error: null
                    },
                    () => {
                      window.SpatialNavigation.focus('.firstButton');
                    }
                  );
                }
              } else {
                this.setState({
                  isFetching: false,
                  error: true
                });
              }
          }
          catch(error) {
            logger.error(error);
          }
    }

    setResume(data) {
        if (data) {
            const { setResumeData } = this.props;
            setResumeData({
                title: data.title,
                year: data.followers,
                rating: '',
                category: data.songs,
                duration: data.duration,
                description: '',
                showBack: false,
                purchaseButtonInfo: true,
                overWrite: true
            });
        }
    }

    renderComponent(component) {
        if (!component || !component.properties || !component.name) {
            return null;
        }
        switch (component.name) {
            case 'Actions':
                const { data } = this.state;
                const props = { ...component.properties };
                if (data.isFollowed) {
                    props.toggleFollow = props.unfollow;
                } else {
                    props.toggleFollow = props.follow;
                }
                delete props.follow;
                delete props.unfollow;
                return (
                    <MusicActions
                        {...props}
                        onToggleFollowClick={this.handleToggleFollowClick}
                        onPlayClick={this.handlePlayClick}
                        onMoreClick={this.handleMoreClick}
                        onKeyDown={this.onKeyDown}
                        device={MusicUtils.getMusicDevice()}
                    />
                );
            case 'Cover':
                return <Cover {...component.properties} />;
            case 'SongList':
                return (
                    <PlayList
                        {...component.properties}
                        onClick={this.handlePlayListOnClick}
                        onFocus={this.handlePlayListOnFocus}
                        onBlur={this.handlePlayListOnBlur}
                        device={MusicUtils.getMusicDevice()}
                    />
                );
            default:
                return null;
        }
    }

    handlePlayClick(index = 0) {
        const { playlistId, data: { tracks = [] } = {} } = this.state;
        const { doPGMPlaylist, playFullMedia } = this.props;
        if (tracks.length > 0) {
            const playerTracks = new PlayerTracksUtil();
            playerTracks.getPlayerTracks(PLAYERTRACK_TYPE.PLAYLIST, playlistId).then(resp => {
                const pgm_musica = doPGMPlaylist(index, {
                    playlistDetail: {
                        tracks,
                        playerTracks: resp
                    }
                });
                if (pgm_musica && pgm_musica.media && pgm_musica.media.video_url) {
                    playFullMedia({
                        playerstate: AAFPLAYER_PLAY,
                        source: {
                            audiosource: pgm_musica.media.video_url
                        },
                        ispreview: false,
                        islive: false,
                        ispip: false
                    });
                }
            });
        }
    }

    handleToggleFollowClick() {
        const { components, data } = this.state;
        const [actionsComponent] = components;
        let url = '';
        if (data.isFollowed) {
            url = actionsComponent.properties.unfollow.url;
        } else {
            url = actionsComponent.properties.follow.url;
        }

        const headers = {};
        api.simpleCMMRequest(url, headers).then(success => {
            if (success) {
                this.setState(prevState => ({
                    data: { ...prevState.data, isFollowed: !prevState.data.isFollowed }
                }));
            }
        });
    }

    handleMoreClick() {
        if (LayersControl.isPlayerVisible()) return;
        const el = document.getElementById('w_canciones').querySelector('.focusable:focus');
        const { playlistId, selectedSong, data: { tracks = [] } = {} } = this.state;
        const { addToContextMenu } = this.props;
        if (el) {
            if (!isNaN(selectedSong) && tracks && tracks[selectedSong]) {
                const song = tracks[selectedSong];
                addToContextMenu({ song, type: PLAYERTRACK_TYPE.PLAYLIST, id: playlistId });
            }
        } else {
            if (tracks && tracks.length > 0) {
                addToContextMenu({
                    tracks: tracks,
                    type: PLAYERTRACK_TYPE.PLAYLIST,
                    id: playlistId
                });
            }
        }

        const context = this.contextMenu.getWrappedInstance();
        context.showModal();
    }

    onKeyDown(e) {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'BLUE':
                this.handlePlayClick();
                break;
            case 'PLAYPAUSE': // for new models samsung tizen small control
            case 'PAUSE':
            case 'PLAY':
                this.handlePlayClick();
                break;
            case 'GREEN':
                this.handleMoreClick();
                break;
            case 'YELLOW':
                this.handleToggleFollowClick();
                break;
            default:
                break;
        }
    }

    handlePlayListOnClick(song) {
        this.handlePlayClick(song.songIndex);
    }

    handlePlayListOnFocus(song) {
        const el = document.getElementById(`song-${song.phonogramId}`);
        el.classList.add('selected-song');
        this.setState({ selectedSong: song.songIndex });
    }

    handlePlayListOnBlur(song) {
        const el = document.getElementById(`song-${song.phonogramId}`);
        el.classList.remove('selected-song');
        this.setState({ selectedSong: song.songIndex });
    }

    render() {
        const { components, error } = this.state;
        const [actionsComponent, coverComponent, songListComponent] = components;
        return (
            <div className="album_resume_container">
                {this.state.isFetching ? (
                    <Spinner className="spinner-music" />
                ) : (
                    <div className="album_container">
                        <Resume />
                        {this.renderComponent(actionsComponent)}
                        <Separator />
                        <div className="w_detail">
                            <div className="w_album">
                                <div>{this.renderComponent(coverComponent)}</div>
                            </div>
                            <div className="w_canciones" id="w_canciones">
                                {
                                    error && <PlaceHolder type={error}/>
                                }
                                {this.renderComponent(songListComponent)}
                            </div>
                        </div>
                    </div>
                )}
                <ContextMenu
                    ref={instance => {
                        this.contextMenu = instance;
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({ user: state.user });
export default connect(mapStateToProps, mapDispatchToProps)(NewPlaylistDetail);



// WEBPACK FOOTER //
// ./src/components/PlaylistDetail/NewPlaylistDetail.jsx